import {
    BRAND_AVAILABLE_SHIPPING_CARRIERS_REQUEST,
    BRAND_SHIPPING_ACCOUNTS_REQUEST,
    BRAND_SHIPPING_CARRIER_COMPLETE,
    BRAND_SHIPPING_CARRIER_REQUEST,
    SHIPPING_ACCOUNT_CARRIER_CREATE,
    SHIPPING_ACCOUNT_CARRIER_DELETE,
    SHIPPING_ACCOUNT_CARRIER_UPDATE,
    SHIPPING_ACCOUNT_CARRIERS_REQUEST,
    SHIPPING_ACCOUNT_CARRIERS_RESET,
    SHIPPING_CARRIER_SERVICES_REQUEST,
} from "constants/action-types";
import type { LoadWorkingOrderAction } from "./working-order-state";

export const fetch = (filters) => ({
    payload: { filters },
    type: BRAND_SHIPPING_ACCOUNTS_REQUEST,
});

export const resetAccountCarriers = () => ({
    type: SHIPPING_ACCOUNT_CARRIERS_RESET,
});

export const resetBrandCarriers = () => ({
    type: BRAND_SHIPPING_CARRIER_COMPLETE,
    payload: null,
    error: undefined,
    data: null,
});

export const fetchAccountCarriers = (meta?: { loadCart: LoadWorkingOrderAction["payload"] }) => ({
    type: SHIPPING_ACCOUNT_CARRIERS_REQUEST,
    meta,
});

export const fetchAvailableCarriers = () => ({
    type: BRAND_AVAILABLE_SHIPPING_CARRIERS_REQUEST,
});

export const createAccountCarrier = (params) => ({
    payload: params,
    type: SHIPPING_ACCOUNT_CARRIER_CREATE,
});

export const updateAccountCarrier = (carrierId, updates) => ({
    payload: {
        carrierId,
        updates,
    },
    type: SHIPPING_ACCOUNT_CARRIER_UPDATE,
});

export const deleteAccountCarrier = (id) => ({
    payload: id,
    type: SHIPPING_ACCOUNT_CARRIER_DELETE,
});

export const fetchAccountCarrier = (id) => ({
    payload: id,
    type: BRAND_SHIPPING_CARRIER_REQUEST,
});

export const fetchCarrierServices = (carrierId) => ({
    payload: carrierId,
    type: SHIPPING_CARRIER_SERVICES_REQUEST,
});
